import { GreenIdCheckResult } from '../../../../types';
import { Entity } from '../../../../types/utility';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const postApplicationGreenIdCheck = async (
  constructPost: ConstructPost,
  uuid: string,
  definitionName: string,
  data: Entity,
): Promise<NonPaginatedResponse<GreenIdCheckResult> | undefined> =>
  constructPost(
    `${APPLICATION_BASE_PATH}/${uuid}/green-id/check`,
    {
      data,
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
    { preventDefaultErrorToast: true },
  );
